import AuthLoginFooter from "./AuthLoginFooter"

export default AuthLoginFooter
